var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"mytime"}},[_vm._v(_vm._s(_vm.str))])])
}
var staticRenderFns = []

export { render, staticRenderFns }